// Pushes the "viewpage" event to the dataLayer on every page view,
// including Shopify section/page (AJAX) loads and browser back/forward.
document.addEventListener('DOMContentLoaded', function () {
  window.dataLayer = window.dataLayer || [];

  var lastPath = null;

  function sendPageViewEvent() {
    if (!window.GTMData) {
      console.warn('GTMData not defined');
      return;
    }

    // Menu triggers using href="#..." push a hash-only history entry (no
    // real navigation). Some browsers fire popstate for that too, which
    // would duplicate this event with an identical payload. Only fire when
    // the actual path changed.
    if (window.location.pathname === lastPath) {
      return;
    }
    lastPath = window.location.pathname;

    window.dataLayer.push({
      event: 'viewpage',
      page_path: window.location.pathname,
      full_url: window.location.origin + window.location.pathname,
      login_status: window.GTMData.login_status,
      user_id: window.GTMData.user_id,
      is_logged_user: window.GTMData.is_logged_user,
      store_country: window.GTMData.store_country?.toLowerCase(),
      store_language: window.GTMData.store_language
    });
  }

  sendPageViewEvent();

  document.addEventListener('shopify:section:load', sendPageViewEvent);
  document.addEventListener('shopify:page:load', sendPageViewEvent);
  window.addEventListener('popstate', sendPageViewEvent);
});
